import React from 'react';
import { PlayerEventAnalysis as PlayerEventAnalysisData } from '@/services/api';
import PitchZoneMap from './PitchZoneMap';
import MiniStat from './MiniStat';

type ZoneMap = Record<string, { count: number; label?: string; color: string; opacity: number }>;

const ShootingSection: React.FC<{
  shooting: PlayerEventAnalysisData['shooting'];
  shotZones: ZoneMap;
}> = ({ shooting, shotZones }) => (
  <div className="mb-6">
    <h5 className="text-sm font-semibold text-gray-800 dark:text-gray-200 mb-3">Shooting</h5>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <PitchZoneMap zones={shotZones} title="Shot Origins by Zone" />

      <div>
        {/* Body part breakdown */}
        <p className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">By Body Part</p>
        <div className="space-y-1.5 mb-4">
          {Object.entries(shooting.byBodyPart).map(([part, stats]) => (
            <div key={part} className="flex items-center justify-between text-xs">
              <span className="text-gray-700 dark:text-gray-300 capitalize">
                {part.replace(/_/g, ' ')}
              </span>
              <span className="text-gray-900 dark:text-gray-100">
                {stats.shots} shots, {stats.goals} goals, {stats.xg.toFixed(2)} xG
              </span>
            </div>
          ))}
        </div>

        {/* Summary stats */}
        <div className="grid grid-cols-3 gap-2">
          <MiniStat label="Total Shots" value={shooting.total} />
          <MiniStat label="On Target" value={shooting.onTarget} />
          <MiniStat label="Goals" value={shooting.goals} />
          <MiniStat label="Conversion" value={`${shooting.conversionPct.toFixed(1)}%`} />
          <MiniStat label="Total xG" value={shooting.totalXg.toFixed(2)} />
          <MiniStat label="xG/Shot" value={shooting.avgXgPerShot.toFixed(3)} />
        </div>
      </div>
    </div>
  </div>
);

export default ShootingSection;
